import bgSpeed from '../../assets/images/news_bg.png';

function Hero() {
  return (
    <section className="relative w-full h-[60vh] md:h-[65vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-center bg-cover"
        style={{ backgroundImage: `url(${bgSpeed})` }}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <h1
          className="special-header text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6"
          style={{ fontFamily: 'Antonio, sans-serif' }}
        >
          INSIGHTS, NEWS & LOGISTICS TIPS
        </h1>
        <p className="text-white text-lg md:text-xl leading-relaxed">
          Stay ahead of the curve with smart insights from the world of logistics, e-commerce, and delivery innovation. From business tips to system updates — we cover it all.
        </p>
      </div>
    </section>
  );
}

export default Hero;
